import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import storeToken, { clearToken } from 'utils/storeToken'
import { getPartners, getUserDetails } from 'services/user'
import actions from './actions'
import menuActions from '../menu/actions'

function* setAccessToken({ payload }) {
  storeToken(payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      accessToken: payload,
    },
  })
}

export function* USER_DETAIL() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      error: '',
    },
  })
  try {
    const [res1 = {}] = yield all([call(getUserDetails)])
    const code = res1?.business?.code
    yield put({
      type: actions.SET_STATE,
      payload: { ...res1 },
    })
    if (res1.business.code) {
      const partnersData = yield call(getPartners, code)
      yield put({
        type: actions.SET_STATE,
        payload: { partnersData },
      })
    }
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    })
  } catch (err) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        error: err?.data?.message || 'Something Went Wrong',
      },
    })
  }
  yield put({ type: menuActions.REFRESH_MENU })
}

export function* LOGOUT() {
  clearToken()
  yield put({ type: actions.RESET_APP })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, setAccessToken),
    takeLatest(actions.USER_DETAIL, USER_DETAIL),
    takeEvery(actions.LOGOUT, LOGOUT),
  ])
}
